import { useState, useEffect } from 'react';
import { makeRequest } from '../utils';

export default function useParkingLot(requestURL) {
  const [parkingLot, setParkingLot] = useState();
  const [parkingLotChange, setParkingLotChange] = useState(false);
  const [requestParkingLot, setRequestParkingLot] = useState(true);

  useEffect(() => {
    // If the dataChange changes back to false, the data has been written to the db and we want to refresh
    if (
      parkingLotChange !== true &&
      !requestURL.includes('undefined') &&
      requestParkingLot === true
    ) {
      makeRequest(requestURL)
        .then((data) => {
          setParkingLot(data);
          setRequestParkingLot(false);
        })
        .catch((error) => {
          console.error(
            `Error fetching Parking Lot from ${requestURL}: ` + error
          );
        });
    }
  }, [requestURL, parkingLotChange, requestParkingLot]);

  const handleParkingLotChange = (rowName, value) => {
    setParkingLot({ ...parkingLot, [rowName]: value });
    setParkingLotChange(true);
  };

  const restParkingLotChange = () => {
    setParkingLotChange(false);
    setRequestParkingLot(true);
  };

  return [
    parkingLot,
    parkingLotChange,
    restParkingLotChange,
    handleParkingLotChange
  ];
}
